import React from 'react';
import { useConnectionRequests } from '../../../contextsProperty/ContextConnectionRequests';
import FiltersBar from '../../../../Table/FiltersBar';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import {
    ConnetionRequestSource,
    IFilterOptionState,
} from '../../../../types/zinantis/connectionRequests/connectionRequestTypes';
import useTranslate from '../../../../customHooks/useTranslate';
import DateInput from '../../../../muiComponents/DateInput';
import { requestsFilterColumnGrid } from '../../../../utils/zinantis/requests/requestsUtils';
import { useConnectionRequestsAuxiliaryData } from '../../../contextsProperty/ContextConnectionRequestsAuxiliaryData';
import RequestsListSendRequest from './sendRequest/RequestsListSendRequest';
import {
    gridSpacing10,
    gridSpacing15,
} from '../../../../utils/commonVariables/grid';

const ZinantisRequestsFiltersBar = () => {
    const {
        resetFilters,
        handleFilterChange,
        handleSearch,
        isLoading,
        currentResults,
        totalResults,
        filters,
        requestedBy,
        isCollapsed,
        toggleCollapse,
    } = useConnectionRequests();
    const translate = useTranslate();

    const { statuses, agencies } = useConnectionRequestsAuxiliaryData();

    const titles = {
        [ConnetionRequestSource.OWNER]: translate('connection_requests_sent'),
        [ConnetionRequestSource.AGENCY]: translate(
            'connection_requests_received'
        ),
    };

    return (
        <div className='zinantis-requests-filters-bar'>
            <FiltersBar
                title={titles[requestedBy]}
                clearFilters={resetFilters}
                search={async () => await handleSearch(1)}
                isLoading={isLoading}
                currentResults={currentResults}
                totalResults={totalResults}
                startButtonBar={
                    requestedBy === ConnetionRequestSource.OWNER ? (
                        <RequestsListSendRequest />
                    ) : undefined
                }
                isCollapsed={isCollapsed}
                toggleCollapse={toggleCollapse}
            >
                <Grid
                    className='flex-grow'
                    columnSpacing={gridSpacing10}
                    rowSpacing={gridSpacing15}
                >
                    <GridChild gridProps={requestsFilterColumnGrid}>
                        <LoadedOptionsTypeahead
                            labelText={'status'}
                            options={statuses.data || []}
                            value={
                                filters.IdZinantisConnectionRequestStatusType
                                    .value || null
                            }
                            handleChange={(
                                e: React.SyntheticEvent<Element, Event>,
                                newValue: IFilterOptionState | null
                            ) =>
                                handleFilterChange(
                                    'IdZinantisConnectionRequestStatusType',
                                    newValue
                                )
                            }
                        />
                    </GridChild>
                    <GridChild gridProps={requestsFilterColumnGrid}>
                        <LoadedOptionsTypeahead
                            labelText={
                                requestedBy === ConnetionRequestSource.OWNER
                                    ? 'requested_to'
                                    : 'requested_by'
                            }
                            options={agencies.data || []}
                            value={filters.IdAgency.value}
                            handleChange={(
                                e: React.SyntheticEvent<Element, Event>,
                                newValue: IFilterOptionState | null
                            ) => handleFilterChange('IdAgency', newValue)}
                        />
                    </GridChild>
                    <GridChild gridProps={requestsFilterColumnGrid}>
                        <DateInput
                            value={filters.RequestedFrom.value}
                            labelText={'requested_from_date'}
                            onChange={(newDate: Date | null) => {
                                handleFilterChange('RequestedFrom', newDate);
                            }}
                        />
                    </GridChild>
                    <GridChild gridProps={requestsFilterColumnGrid}>
                        <DateInput
                            value={filters.RequestedTo.value}
                            labelText={'requested_to_date'}
                            onChange={(newDate: Date | null) => {
                                handleFilterChange('RequestedTo', newDate);
                            }}
                        />
                    </GridChild>
                </Grid>
            </FiltersBar>
        </div>
    );
};

export default ZinantisRequestsFiltersBar;
